import { ChangeEvent, Children } from "react";
import React, { FC, useState, useEffect, memo } from "../../../lib/teact/teact";
import './lotSelect.scss'

type OwerProp = {
    value: string;
    onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
    children: React.ReactNode,
    id: string,
    extraClassName?:string;
    styleEx?:string;
}

const LotSelect: FC<OwerProp> = ({
    value,
    onChange,
    children,
    id,
    extraClassName,
    styleEx
}) => {
    return (
        <select className={"lot-select "+ (extraClassName?extraClassName:"")}
            id={id}
            value={value || ''}
            onChange={onChange} style={styleEx?styleEx:""}>
            {children}
        
        </select>
    )
}
export default LotSelect